import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import Error from '@components/Error/Error'
import PageHeading from '@components/PageHeading/PageHeading'
import Table from '@components/pages/Transaction/DetailsTable'
import GET_TRANSACTION from '@graphql/queries/get-transaction'

function Details() {
  const { transactionId } = useParams()
  const [fields, setFields] = useState([])
  const EXCLUDE_FROM_FIELDS = ['__typename', 'transactionBatch']
  const { data, loading, error } = useQuery(GET_TRANSACTION, {
    variables: { id: transactionId },
    onCompleted: (data) => setFields(Object.keys(data.transaction).filter((key) => !EXCLUDE_FROM_FIELDS.includes(key)))
  })

  return (
    <>
      <PageHeading heading='Transaction Details' />

      {error ? (
        <Error error={error} />
      ) : (
        <Table
          transaction={data?.transaction}
          fields={fields}
          loading={loading}
        />
      )}
    </>
  )
}

export default Details
